import { accidentActions } from '@/entity'
import { api } from '@/shared'
import { message } from 'antd'
import i18next, { t } from 'i18next'
import { actRecall } from '@/shared/api/rest/act'
import dayjs from 'dayjs'

export const getAccidents = (page, size) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.toggleError(null))
			dispatch(accidentActions.toggleLoading(true))
			const result = await api.accidents.getAll({ page, size })
			dispatch(accidentActions.setAccidents(result))
			dispatch(accidentActions.toggleSuccess(true))
			dispatch(accidentActions.toggleLoading(false))
		} catch (error) {
			dispatch(accidentActions.toggleError(error))
			dispatch(accidentActions.toggleSuccess(false))
			message.error(error?.response?.data?.message)
		} finally {
			dispatch(accidentActions.toggleLoading(false))
		}
	}
}

export const getAccidentsRepresentative = (page, size) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.toggleError(null))
			dispatch(accidentActions.toggleLoading(true))
			const result = await api.accidents.getAllRepresentative({ page, size })
			dispatch(accidentActions.setAccidents(result))
			dispatch(accidentActions.toggleSuccess(true))
			dispatch(accidentActions.toggleLoading(false))
		} catch (error) {
			dispatch(accidentActions.toggleError(error))
			dispatch(accidentActions.toggleSuccess(false))
			message.error(error?.response?.data?.message)
		} finally {
			dispatch(accidentActions.toggleLoading(false))
		}
	}
}

export const saveReport = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.toggleLoading(true))
			const result = await api.accidents.saveReport(data)

			onSuccess(result)
			dispatch(accidentActions.toggleLoading(false))
		} catch (error) {
			message.error(error?.response?.data?.message)
		} finally {
			dispatch(accidentActions.toggleLoading(false))
		}
	}
}

export const sendSignedReport = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.toggleLoadingSend(true))
			const result = await api.accidents.sendReport(data)
			if (result === '') {
				dispatch(accidentActions.toggleSuccessSend(true))
			}
			onSuccess()
		} catch (error) {
			message.error(error?.response?.data?.message)
			dispatch(accidentActions.resetReportXml())
			dispatch(accidentActions.toggleLoadingSend(false))
		} finally {
			dispatch(accidentActions.toggleLoadingSend(false))
		}
	}
}

export const getAccident = (externalId) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.setAccident(null))
			dispatch(accidentActions.toggleLoading(true))
			const result = await api.accidents.getAccident(externalId)
			dispatch(accidentActions.setAccident(result))
			dispatch(accidentActions.toggleLoading(false))
		} catch (error) {
			dispatch(accidentActions.toggleSuccess(false))
			dispatch(accidentActions.setAccident(null))
			message.error(error?.response?.data?.message)
		} finally {
			dispatch(accidentActions.toggleLoading(false))
		}
	}
}

export const getPerson = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.getPerson())

			const getPersonByContract = await api.staff.getContractData(data)
			let res

			if (getPersonByContract?.contractDatas?.length) {
				res = {
					...getPersonByContract,
					fio: getPersonByContract?.fio,
					surname: getPersonByContract?.surname,
					firstname: getPersonByContract?.firstname,
					secondname: getPersonByContract?.patronname,
					birthDate: getPersonByContract?.birthDate,
					contractDatas: getPersonByContract?.contractDatas?.map((i, idx) => ({
						...i,
						establishedPost: {
							...i.establishedPost,
							key: `${idx}-${i.establishedPost?.code}`,
							kz: i.establishedPost?.nameKz,
							rus: i.establishedPost?.nameRu,
						},
					})),
				}
				dispatch(accidentActions.getPersonDone(res))
			} else {
				const getByFlData = await api.contracts.getFLData(data)

				if (getByFlData.fio !== null) {
					res = {
						...getByFlData,
						iin: data?.iin,
						fio: getByFlData?.fullNamePerson,
						surname: getByFlData?.surname,
						firstname: getByFlData?.firstname,
						secondname: getByFlData?.patronname,
						birthDate: getByFlData?.birthDate,
					}
					dispatch(accidentActions.getPersonDone(res))
				} else {
					onError()
					dispatch(accidentActions.getPersonFail())
					message.error(i18next.t('person_not_found'), 10)
				}
			}

			onSuccess(res)
		} catch (error) {
			dispatch(accidentActions.getPersonFail())
			onError()
			message.error(error?.response?.data?.message)
		}
	}
}

export const sendSeverity = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendSeverity())
			const result = await api.severity.sendSeverity(data)

			dispatch(accidentActions.sendSeverityDone(result))
			onSuccess(result)
		} catch (error) {
			onError()
			dispatch(accidentActions.sendSeverityFail())
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
		}
	}
}

export const sendSeverityXml = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendSeverityXml())
			const result = await api.severity.sendSeverityXml(data)

			dispatch(accidentActions.sendSeverityXmlDone(result))
			onSuccess(result)
		} catch (e) {
			onError()
			dispatch(accidentActions.sendSeverityXmlFail())
		}
	}
}

export const sendInvestigation = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendInvestigation())
			const result = await api.severity.sendInvestigation(data)

			dispatch(accidentActions.sendInvestigationDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error?.response?.data?.message)
			onError()
			dispatch(accidentActions.sendInvestigationFail())
		}
	}
}

export const sendInvestigationXml = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendInvestigationXml())
			const result = await api.severity.sendInvestigationXml(data)

			dispatch(accidentActions.sendInvestigationXmlDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error?.response?.data?.message)
			onError()
			dispatch(accidentActions.sendInvestigationXmlFail())
		}
	}
}

export const sendComission = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendComission())
			const result = await api.severity.sendComission(data)

			dispatch(accidentActions.sendComissionDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error?.response?.data?.message)
			onError()
			dispatch(accidentActions.sendComissionFail())
		}
	}
}

export const sendComissionXml = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendComissionXml())
			const result = await api.severity.sendComissionXml(data)

			dispatch(accidentActions.sendComissionXmlDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error?.response?.data?.message)
			onError()
			dispatch(accidentActions.sendComissionXmlFail())
		}
	}
}

export const getInvestigationReport = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.getInvestigationReport())
			const result = await api.severity.getInvestigationReport(data)

			if (result) {
				dispatch(accidentActions.getInvestigationReportDone(result))
				onSuccess(result)
			} else {
				onError()
			}
		} catch (error) {
			message.error(error?.response?.data?.message)
			onError()
			dispatch(accidentActions.getInvestigationReportFail())
		}
	}
}

export const getFillingAct = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.getFillingAct())
			const result = await api.fillingAct.actCreate(data)

			dispatch(accidentActions.getFillingActDone(result))
			onSuccess(result)
		} catch (error) {
			onError()
			dispatch(accidentActions.getFillingActFail())
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
		}
	}
}

export const getRepresentative = (externalId) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.getActRepresentative())
			const result = await api.accidents.getRepresentative(externalId)
			let res = {
				...result,
				pdfDtos: result?.pdfDtos?.map((i, idx) => ({ ...i, key: `key-${idx}` })),
			}
			dispatch(accidentActions.getActRepresentativeDone(res))
		} catch (error) {
			dispatch(accidentActions.getActRepresentativeFail())
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
		}
	}
}

export const sendRepresentativeXml = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendActRepresentativeXml())
			const result = await api.accidents.sendRepresentativeXml(data)

			dispatch(accidentActions.sendActRepresentativeXmlDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
			onError()
			dispatch(accidentActions.sendActRepresentativeXmlFail())
		}
	}
}

export const sendRepresentative = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendActRepresentative())
			const result = await api.accidents.sendRepresentative(data)

			dispatch(accidentActions.sendActRepresentativeDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
			onError()
			dispatch(accidentActions.sendActRepresentativeFail())
		}
	}
}

export const sendActXml = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendFillingActXml())
			const result = await api.fillingAct.sendActXml(data)

			dispatch(accidentActions.sendFillingActXmlDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
			onError()
			dispatch(accidentActions.sendFillingActXmlFail())
		}
	}
}

export const sendAct = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.sendFillingAct())
			const result = await api.fillingAct.sendAct(data)

			dispatch(accidentActions.sendFillingActDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
			onError()
			dispatch(accidentActions.sendFillingActFail())
		}
	}
}

export const recallAct = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(accidentActions.recallFillingAct())
			const result = await api.fillingAct.actRecall(data)
			dispatch(accidentActions.recallFillingAct(result))
			onSuccess(result)
		} catch (error) {
			message.error(error && error.response && error.response.data ? error.response.data.message : t('unknown_error'))
			dispatch(accidentActions.recallFillingActFail())
			onError()
		}
	}
}
